<style scoped>
	.edi-detail-bill .detail-bill-footer div.detail-bill-info p.total-p {
		margin: .5em 5px;
		font-size: 1em;
	}
	.bill-all-info-width {
		width: 100%;
	}
	.bill-all-info .detail-bill-info-list li {
		padding: 10px 1.2em;
	}
	.edi-detail-bill .detail-bill-list-flex{
		width: 100%;
	}
	.edi-detail-bill .detail-bill-list-flex-li {
		display: flex;
		flex-direction: row;
		justify-content: left;
		align-items: center;
	}
	.edi-detail-bill .detail-bill-sonlists{
		width: 50%;
		float: none;
	}
	.edi-detail-bill .detail-bill-sonlists div {
		float:none;
		word-break: break-all;
		margin: 10px 0;
		font-size: .8em;
		color: #656565;
		box-sizing: border-box;
	}
	.edi-detail-bill .detail-bill-sonlist-font{
		font-size: 0.9em;
		font-weight: bolder;
	}
	.detail-bill-organs {
		background-color: #ffffff;
		padding: 1em;
		font-size: .8em;
		margin: 1px;
	}
	.detail-bill-btn {
		float: right;
		background: cornflowerblue;
		color: white;
		border: none;
		width: 56px;
		height: 24px;
		border-radius: 3px;
	}
	.edi-detail-bill .detail-bill-items-link {
		width: 10px;
		height: 15px;
		right: .7em;
		margin-top: 2px;
		background-size: 10px 15px;
		background-image: url("../assets/listview-arrow.jpg");
	}
	.detail-bill-fulllist-left, .detail-bill-fulllist-right {
		display: inline-block;
	}
	.detail-bill-fulllist-right {
		float: right;
	}
	.detail-bill-files {
		border-bottom: 1px solid #ccc;
	}
	.detail-bill-organs-name {
		display: inline-block;
		width: 80%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>
<template>
	<div class="edi-detail-bill">
		<navbar title="供货商对账单-明细"></navbar>
		<div v-show="scrollShow" class="common-scroll detail-scroll">
			<p class="detail-bill-status">系统单号：{{returnDetailData.trans_bill_no}}
				<span class="nav-btn" @click="openBillInfo()">
					<img src="../assets/nav-btn.png" alt="">
				</span>
				<!-- * 单据状态  0:未对账 1:待确认；2：已对账；3：被退回 -->
				<span v-if="returnDetailData.bill_state == 0" class="state-grey-font">未对账</span>
				<span v-if="returnDetailData.bill_state == 1" class="state-red-font">已对账</span>
			</p>
			<p class="detail-bill-organs">
				<span class="detail-bill-organs-name">{{returnDetailData.to_organ_name || '门店'}}</span>
				<button class="detail-bill-btn" @click.stop="onSeeOrgansClick">查看</button>
			</p>
			<div class="detail-bill-files">
				<div class="upload-file-div" v-if="uploadDeliverFlag !== undefined && !isZ5">
					<label>附件资料：</label>
					<upload-img
						:uploadImgState="uploadImgState"
						:uploadImgList='uploadImgList'
						:imgListLength='3'
						:smallDelIco='smallDelIco'
						:billState='Number(returnDetailData.bill_state)'
						@update:smallDelIco='smallDelIco = $event'
						@attachDelPost='attachDelPost'
						@attachBeforeUpload='attachBeforeUpload'
						@attachClick='attachClick'
					></upload-img>
				</div>
			</div>
			<div class="detail-bill-files">
				<div class="upload-file-div" v-if="uploadDeliverFlag !== undefined && !isZ5">
					<label>PC附件资料：</label>
					<upload-img
						:uploadImgState="false"
						:uploadImgList='uploadImgListPC'
						:imgListLength='3'
						:billState='Number(returnDetailData.bill_state)'
						@update:smallDelIco='smallDelIco = $event'
						@attachClick='attachClick'
					></upload-img>
				</div>
			</div>
			<div class="bill-all-info bill-all-info-width">
				<ul class="detail-bill-info-list bill-all-info-width">
					<li class="detail-bill-fulllist">业务日期：{{returnDetailData.from_date}}</li>
					<li class="detail-bill-fulllist">
						<div class="detail-bill-fulllist-left">
							明细数：{{returnDetailData.bill_dt_count | numFixed2(4)}}
						</div>
						<!-- ui-btn-icon-right ui-icon-carat-r -->
						<!-- <router-link :to="{ path: '/all-return-bill', query: { bill_state: '20,21',bill_font: '未确认,已确认' }}"></router-link> -->
						<div class="detail-bill-fulllist-right detail-bill-items-link" @click="onDtItems"></div>
					</li>
					<li class="detail-bill-fulllist">非税金额：{{returnDetailData.instore_sum_money | numFixed2(4)}}</li>
					<li class="detail-bill-fulllist">含税金额：{{returnDetailData.include_tax_sum_money | numFixed2(4)}}</li>
					<li class="detail-bill-fulllist">备注：{{returnDetailData.remark}}</li>
				</ul>
			</div>
		</div>
		<div v-show="scrollShow" class="detail-bill-footer">
			<div v-if="buttonState && returnDetailData.bill_state != 1" class="detail-bill-return f-right">
				<a @click="agreen('1')">同意</a>
			</div>
			<div v-if="buttonState && returnDetailData.bill_state != 1" class="detail-bill-red f-right">
				<a @click="refuseB">退回</a>
			</div>
		</div>
		<loading v-show="loading"></loading>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
		<tips v-show="tips" :btnNum="btnNum" :tipsFont="tipsFont" v-on:tipStatus="tipStatus"></tips>
		<tips v-show="tipsB" :btnNum="btnNum" :tipsFont="tipsFont" v-on:tipStatus="tipStatusB"></tips>
		<tips v-show="tipsOrgans" :btnNum="btnNum1" :tipsFont="tipsFontOrgans" v-on:tipStatus="tipStatusOrgan"></tips>
		<item-img ref="itemImgRef"></item-img>
		<dt-items ref="dtItemsRef" :restaurantId="restaurantId"></dt-items>
	</div>
</template>

<script>
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'
import ItemImg from '../components/ItemImg'
import UploadImg from '../components/Upload'
import SupplierAccountCheckDetailBillDt from './SupplierAccountCheckDetailBillDt'
export default {
	data () {
		return {
			bill_no: '',
			uploadImgState: true,
			buttonState: true,
			scrollShow: false,
			tips: false,
			tipsB: false,
			tipsOrgans: false,
			btnNum: 2,
			btnNum1: 1,
			loading: true,
			tipsauto: false,
			tipsFont: '',
			tipsFontOrgans: '',
			sec: 1500,
			returnDetailData: {},
			returnDetails: {},
			otherdata: {},
			queryData: this.$route.query,
			show: false,
			billInfoShow: false,
			smallDelIco: false,
			isZ5: false,
			uploadDeliverFlag: false, // 不上传附件不允许发单。undefined: 没有此功能；true: 不上传附件不允许发单；false: 不上传附件允许发单
			uploadImgList: [],
			uploadImgListPC: [],
			attachUploadUrl: '/cldEdi/reconciliation/uploadEnclosure'
		}
	},
	components: {
		'loading': Loading,
		'tips-auto': TipsAuto,
		'tips': Tips,
		'navbar': NavBar,
		'item-img': ItemImg,
		'upload-img': UploadImg,
		'dt-items': SupplierAccountCheckDetailBillDt
	},
	created () {
		this.loading = true
		this.bill_no = this.queryData.bill_no
		console.log(this.queryData)
		var filterData = {
			id: this.queryData.bill_id
		}
		this.$http.post('/cldEdi/reconciliation/one', filterData).then((response) => {
			this.loading = false
			this.scrollShow = true
			let result = response.body
			if (!result.result) {
				this.uploadImgState = false
				this.buttonState = false
				this.$fxToast.warning(result.message)
				this.$router.push({path: '/main/home'})
				return false
			} else {
				this.returnDetailData = response.body.data
				console.log(this.returnDetailData)
				this.isZ5 = response.body.otherdata == null ? false : response.body.otherdata.isZ5
				this.returnDetails = response.body.data
				// this.otherdata = response.body.otherdata
				if (this.returnDetailData.bill_state === 1) {
					this.uploadImgState = false
				} else {
					this.uploadImgState = true
				}
				// 获取附件列表
				// if (!this.isZ5 && this.uploadDeliverFlag !== undefined) {
				if (!this.isZ5) {
					this.getUploadPost()
				}
			}
		}, (response) => {
			this.loading = false
			this.autoTips('服务请求失败，稍后请重试！')
		})
	},
	methods: {
		// 获取附件列表
		getUploadPost () {
			this.$http.post('/cldEdi/reconciliation/showEnclosure', {id: this.queryData.trans_bill_id}).then((response) => {
				var res = response.body
				if (res.result) {
					// this.uploadImgList = res.data
					this.uploadImgList = this.getUploadImgList(res.data).imgList
					this.uploadImgListPC = this.getUploadImgList(res.data).imgListPc
				} else {
					this.autoTips(res.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		onSeeOrgansClick () {
			this.tipsOrgans = true
			if (this.returnDetailData.to_organ_name.length > 0) {
				this.tipsFontOrgans = this.returnDetailData.to_organ_name
			}
		},
		onDtItems1 () {
			this.onDtItems().then((res) => {
				// this.loading = false
				// this.scrollShow = true
				this.$refs.dtItemsRef.open()
			})
		},
		// 删除或者预览
		// seeOrDel (list) {
		// 	if (this.smallDelIco) {
		// 		this.attachDel(list.id)
		// 	} else {
		// 		this.attachClick(list.path)
		// 	}
		// },
		onDtItems () {
			this.loading = true
			this.bill_no = this.queryData.bill_no
			console.log(this.queryData)
			var filterData = {
				// bill_id: this.queryData.bill_id, // todo-wwwww 40289bda8b6b44de018b6b4891bb0000
				reconciliation_bill_id: this.queryData.trans_bill_id
			}

			this.$http.post('/cldEdi/reconciliation/getItemDetail', filterData).then((response) => {
				this.loading = false
				this.scrollShow = true
				let result = response.body
				if (!result.result) {
					this.uploadImgState = false
					this.buttonState = false
					this.$fxToast.warning(result.message)
					this.$router.push({path: '/main/home'})
					return false
				} else {
					var itemList = response.body.data
					this.$refs.dtItemsRef.open(itemList)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		attachAdd () {
			if (this.uploadImgList.length < this.otherdata.number) {
				this.$refs.attachInput.click()
			} else {
				this.autoTips('最多只能上传三个附件')
			}
		},
		attachDel (imgId) {
			this.btnFont = ['确定', '取消']
			this.tipsFont = '确定要删除附件吗？'
			this.tipsTShow('delAttach' + '+' + imgId)
		},
		attachBeforeUpload (attachFile, attachInput) {
			this.loading = true
			let uploadData = new window.FormData()
			uploadData.append('file', attachFile)
			uploadData.append('id', this.queryData.trans_bill_id)
			uploadData.append('number', String(this.otherdata.number))
			this.$http.post(this.attachUploadUrl, uploadData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((response) => {
				let data = response.body
				if (!data.result) {
					this.loading = false
					this.autoTips(data.data.cause || '上传附件失败')
				} else {
					if (data.data.success) {
						this.uploadImgList.push(data.data.billFiles)
						this.loading = false
						this.autoTips('上传附件成功')
					} else {
						attachInput.value = ''
						this.loading = false
						this.autoTips(data.data.cause)
					}
				}
			}, (response) => {
				attachInput.value = ''
				this.loading = false
				this.autoTips('请求失败，稍后请重试！')
			})
		},
		attachDelPost (imgId, attachInput) {
			let postData = {
				id: imgId
			}
			this.loading = true
			this.$http.post('/cldEdi/reconciliation/deleteEnclosure', postData).then((response) => {
				let data = response.body
				if (!data.result) {
					this.loading = false
					this.autoTips(data.message || '删除附件失败')
				} else {
					attachInput.value = ''
					this.loading = false
					this.autoTips('删除附件成功')
					this.smallDelIco = false
					var tempArr = []
					this.uploadImgList.forEach((e) => {
						if (e.id !== imgId) {
							tempArr.push(e)
						}
					})
					this.uploadImgList = tempArr
				}
			}, (response) => {
				this.loading = false
				this.autoTips('请求失败，稍后请重试！')
			})
		},
		/* 点击预览图片 */
		attachClick (url) {
			this.$refs.itemImgRef.open(url)
		},
		// 取消删除附件回调事件
		cancelDel (msg) {
			this.smallDelIco = false
		},
		/* 上传附件结束 */
		infoExchange () {
			this.show = !this.show
		},
		tipStatus (msg) {
			this.tips = false
			this.msg = msg
			this.refuseBack()
		},
		tipStatusB (msg) {
			this.tipsB = false
			this.msg = msg
			if (this.msg[1] === true) {
				this.refuse()
				return false
			}
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		tipStatusOrgan (msg) {
			this.tipsOrgans = false
			this.msg = msg
			if (this.msg[1] === true) {
				this.refuse()
				return false
			}
		},
		agreen (state) {
			this.loading = true
			var updateData = {
				bill_state: state,
				id: this.queryData.bill_id
			}
			this.$http.post('/cldEdi/reconciliation/update', updateData).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.buttonState = false
					this.uploadImgState = false
					this.returnDetailData.bill_state = state
					this.autoTips('对账单已对账')
				} else {
					this.autoTips('失败')
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		refuse () {
			this.tips = true
			this.tipsFont = '确认退回订单？'
		},
		refuseB () {
			this.tipsB = true
			this.tipsFont = '对账单退回后将不可撤销，是否继续？'
		},
		refuseBack (state) {
			if (this.msg[1]) {
				this.loading = true
				var updateData = {
					bill_state: '2',
					id: this.queryData.bill_id
				}
				this.$http.post('/cldEdi/reconciliation/update', updateData).then((response) => {
					this.loading = false
					var self = this
					var data = response.body
					if (data.result) {
						this.buttonState = false
						this.returnDetailData.bill_state = 0
						this.autoTips('对账单已退回')
						setTimeout(function () {
							self.$router.go(-1)
						}, 1500)
					} else {
						this.autoTips('失败')
					}
				}, (response) => {
					this.loading = false
					this.autoTips('服务请求失败，稍后请重试！')
				})
			} else {
				return false
			}
		},
		openBillInfo () {
			this.billInfoShow = !this.billInfoShow
		},
		getUploadImgList (files) {
			var imgList = []
			var imgListPc = []
			for (var i = 0; i < files.length; i++) {
				if (files[i].type === 'PCUpload') {
					imgListPc.push(files[i])
				} else {
					imgList.push(files[i])
				}
			}
			return {
				imgList: imgList,
				imgListPc: imgListPc
			}
		}
	},
	filters: {
		// edi小数位数处理
		numFixed2 (val, scale) {
			if ((typeof val === 'string' && val !== '') || typeof val === 'number') {
				if (scale) {
					return parseFloat(val.toFixed(scale))
				} else {
					return val
				}
			} else {
				return val
			}
		}
	}
	// computed: {
	// 	sumSubTotalSend () {
	// 		let sumSubTotalSend = 0
	// 		if (this.returnDetails) {
	// 			for (let i = 0; i < this.returnDetails.length; i++) {
	// 				sumSubTotalSend += this.returnDetails[i].sub_total_send
	// 			}
	// 		}
	// 		sumSubTotalSend = parseFloat((sumSubTotalSend).toFixed(2))
	// 		return sumSubTotalSend
	// 	}
	// }
}
</script>



// WEBPACK FOOTER //
// SupplierAccountCheckDetailBill.vue?5ee038a5